import React from 'react';

const TermsPage = () => {
    return (
        <div>
            <h1>Terms of Use</h1>
        </div>
    );
};

export default TermsPage;
